import WorkspaceService from "@core-ui/ContextServices/Workspace";
import { useIsEditorApp } from "@core-ui/hooks/useIsEditorApp";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { extractCatalogName } from "@core-ui/utils/extractCatalogName";
import { AgentChatPanel } from "@ext/agent/components/panel/AgentChatPanel";
import { AgentSkillsPanel } from "@ext/agent/components/skills/panel/AgentSkillsPanel";
import { CatalogReportPanel } from "@ext/catalog/report/components/CatalogReportPanel";
import { CatalogViewPanel } from "@ext/catalog/views/components/CatalogViewPanel";
import { BranchPanel } from "@ext/git/actions/Branch/BranchPanel/BranchPanel";
import { HistoryPanel } from "@ext/git/actions/Revisions/HistoryPanel/HistoryPanel";
import { MergeRequestPanel } from "@ext/git/core/GitMergeRequest/MergeRequestPanel/MergeRequestPanel";
import { MergeRequestStateSync } from "@ext/git/core/GitMergeRequest/MergeRequestPanel/MergeRequestStateSync";
import { PublishPanel } from "@ext/git/core/GitPublish/PublishPanel/PublishPanel";
import { InboxPanel } from "@ext/inbox/components/InboxPanel/InboxPanel";
import { FragmentsPanel } from "@ext/markdown/elements/fragment/edit/components/FragmentsPanel/FragmentsPanel";
import { ReviewPanel } from "@ext/review/components/ReviewPanel/ReviewPanel";
import PermissionService from "@ext/security/logic/Permission/components/PermissionService";
import { editCatalogContentPermission } from "@ext/security/logic/Permission/Permissions";
import { TemplatesPanel } from "@ext/templates/components/TemplatesPanel/TemplatesPanel";

export const CatalogFloatingPanels = () => {
	const { isNext } = usePlatform();
	const isEditorApp = useIsEditorApp();
	const workspacePath = WorkspaceService.current()?.path;
	const catalogName = useCatalogPropsStore((state) => extractCatalogName(state.data?.name));
	// A reviewer is read-only on any branch outside their list; the panel is how they reach an allowed one.
	const canEditCatalogContent = PermissionService.useCheckPermission(
		editCatalogContentPermission,
		workspacePath,
		catalogName,
	);

	return (
		<>
			{!isNext && <MergeRequestStateSync />}
			{isEditorApp && (
				<>
					<PublishPanel />
					<MergeRequestPanel />
					<ReviewPanel />
					<InboxPanel />
					<CatalogReportPanel />
					<AgentChatPanel />
					<AgentSkillsPanel />
					<TemplatesPanel />
					<FragmentsPanel />
				</>
			)}
			{isNext && <AgentChatPanel />}
			<CatalogViewPanel />
			{!isNext && <HistoryPanel />}
			{(isNext || canEditCatalogContent) && <BranchPanel />}
		</>
	);
};
